import React, { useEffect, useState } from "react";
import { apiAdmin } from "../../lib/api";
import { Eye, Trash2, X } from "lucide-react";
import { toast } from "sonner";

const STATUSES = ["nuevo", "contactado", "cotizado", "cerrado"];

const Quotes = () => {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => apiAdmin.get("/quotes").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => { await apiAdmin.put(`/quotes/${id}/status`, { status }); toast.success("Estado actualizado"); load(); };
  const remove = async (id) => { if (!window.confirm("¿Eliminar?")) return; await apiAdmin.delete(`/quotes/${id}`); toast.success("Eliminado"); load(); };

  return (
    <div data-testid="admin-quotes">
      <div className="mb-10">
        <span className="text-xs uppercase tracking-[0.25em] font-bold text-yolk">─ Cotizaciones ─</span>
        <h1 className="mt-2 font-heading text-4xl font-bold text-brand-ink">Solicitudes de cotización</h1>
      </div>
      <div className="bg-white border-2 border-black rounded-3xl overflow-hidden overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-yolk text-left text-xs uppercase tracking-wider text-white border-b-2 border-black">
            <tr>
              <th className="px-6 py-4 font-bold">Cliente</th>
              <th className="px-6 py-4 font-bold">Servicio</th>
              <th className="px-6 py-4 font-bold">Teléfono</th>
              <th className="px-6 py-4 font-bold">Estado</th>
              <th className="px-6 py-4 font-bold">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y-2 divide-black/10">
            {items.length === 0 ? (
              <tr><td colSpan={5} className="px-6 py-12 text-center text-gray-400">Sin cotizaciones</td></tr>
            ) : items.map((q) => (
              <tr key={q.id} data-testid={`quote-row-${q.id}`}>
                <td className="px-6 py-4 font-medium">{q.nombre}</td>
                <td className="px-6 py-4 text-gray-600">{q.servicio}</td>
                <td className="px-6 py-4 text-gray-600">{q.telefono}</td>
                <td className="px-6 py-4">
                  <select value={q.status} onChange={(e) => updateStatus(q.id, e.target.value)} data-testid={`quote-status-${q.id}`} className="text-xs border-2 border-black px-2 py-1 bg-white">
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-6 py-4 flex gap-2">
                  <button onClick={() => setSelected(q)} data-testid={`quote-view-${q.id}`} className="p-2 hover:bg-yolk-light"><Eye className="h-4 w-4" /></button>
                  <button onClick={() => remove(q.id)} data-testid={`quote-delete-${q.id}`} className="p-2 hover:bg-red-50"><Trash2 className="h-4 w-4 text-red-500" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selected && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-6" onClick={() => setSelected(null)}>
          <div className="bg-white border-2 border-black max-w-xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-6 border-b-2 border-black">
              <h2 className="font-heading text-xl font-bold">Cotización #{selected.id.slice(0, 8).toUpperCase()}</h2>
              <button onClick={() => setSelected(null)} className="p-2 hover:bg-yolk-light"><X className="h-4 w-4" /></button>
            </div>
            <div className="p-6 space-y-4">
              <D label="Nombre" value={selected.nombre} />
              <D label="Teléfono" value={selected.telefono} />
              <D label="Correo" value={selected.correo} />
              <D label="Servicio" value={selected.servicio} />
              <D label="Descripción" value={selected.descripcion} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const D = ({ label, value }) => (
  <div>
    <p className="text-xs uppercase tracking-[0.18em] text-gray-400 mb-1 font-bold">{label}</p>
    <p className="text-sm text-brand-ink whitespace-pre-wrap">{value}</p>
  </div>
);

export default Quotes;
